import { useEffect, useRef, useState } from 'react';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID || '793723617667-8o8teaio1lf2c9jk9b3nubhvo0oh85dr.apps.googleusercontent.com';
let loader;
function loadGoogle() {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (!loader) loader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = resolve;
    script.onerror = () => { loader = null; script.remove(); reject(new Error('Google bağlantısı açılamadı.')); };
    document.head.appendChild(script);
  });
  return loader;
}

export default function GoogleAccountButton({ onCredential, disabled = false }) {
  const container = useRef(null);
  const callback = useRef(onCredential);
  callback.current = onCredential;
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    loadGoogle().then(() => {
      if (!active || !container.current) return;
      window.google.accounts.id.initialize({ client_id: CLIENT_ID, callback: (result) => {
        if (active) callback.current(result.credential);
      } });
      window.google.accounts.id.renderButton(container.current, { theme: 'outline', size: 'large', text: 'continue_with', shape: 'pill', width: 280 });
    }).catch((err) => { if (active) setError(err.message); });
    return () => { active = false; };
  }, []);
  return <div className="my-4 flex flex-col items-center gap-2" style={{ pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.5 : 1 }}>
    <div ref={container} />
    {error && <p role="alert" className="text-xs text-red-600">{error} E-posta ile devam edebilirsiniz.</p>}
  </div>;
}
